module.exports = __webpack_public_path__ + "static/img/member-2.28ad96ef.png";